export const isMarcFormat = (name: string) => name === 'MARC';
